import { render, staticRenderFns } from "./inputSelectMap.pug?vue&type=template&id=37a84836&lang=pug&"
import script from "./inputSelectMap.js?vue&type=script&lang=js&"
export * from "./inputSelectMap.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\CVM7Z9V\\OneDrive - Allianz\\Escritorio\\apps\\mavalue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37a84836')) {
      api.createRecord('37a84836', component.options)
    } else {
      api.reload('37a84836', component.options)
    }
    module.hot.accept("./inputSelectMap.pug?vue&type=template&id=37a84836&lang=pug&", function () {
      api.rerender('37a84836', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/input/modules/selectmap/index.vue"
export default component.exports